import { Component, computed, input } from '@angular/core';

export type BadgeColor =
  | 'light-grey'
  | 'grey'
  | 'grey-solid'
  | 'dark-grey-solid'
  | 'black-solid'
  | 'blue'
  | 'blue-solid'
  | 'green'
  | 'green-solid'
  | 'red'
  | 'red-solid'
  | 'yellow'
  | 'yellow-solid'
  | 'purple';

export type ComponentSize = 'normal' | 'small';

@Component({
  selector: 'glxy-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  host: {
    '[class]': 'badgeClass()',
  },
})
export class BadgeComponent {
  // Predefined named color for badge: grey, green, red, blue, black-solid, etc
  color = input<BadgeColor>('grey');
  // Predefined size: normal (default) | small
  size = input<ComponentSize>('normal');

  badgeClass = computed(() => `glxy-badge glxy-badge--${this.color()} glxy-badge--${this.size()}`);
}
